import styled from "styled-components";
import theme from "../../styles/theme";
import { CommonModalWrap, OneList } from "../../styles/common";
import { useQueryClient } from "react-query";
import { useCallback, useEffect, useState } from "react";
import CommonModalBar from "../common/CommonModalBar";
import { useGetCarClassDetail, useGetCarClassList, useSetCarsClass } from "../../interfaces/carsClass";
import { Button, TextField } from "@mui/material";
import { MODAL_QUERY_NM } from "../../interfaces/modal";

const CarsClassDetail = ({ onClick}) => {

    const {data} = useGetCarClassList();

    const [target, setTarget] = useState();
    const [popOpen, setPopOpen] = useState(false);

    useEffect(()=>{
        setTarget();
    },[data])

    const handleTargetClick = (item) => {
        setTarget(item);
        onClick(item);
    }

    return (
        <div className="list">
            <OneList>
                <ul className="titleLine">
                    <li>
                        <span>&nbsp;</span>
                        <span>차종유형</span>
                    </li>
                </ul>
                <ul className="descArea">
                    {data && data.map((item,index)=>{
                        return(
                            <li key={index} className={'descLiItem '+((target && target.ccid===item.ccid) ? 'selected':'')} onClick={()=>handleTargetClick(item)}>
                                <span></span>
                                <span>{item.ccnm}</span>
                            </li>
                        )
                    })}
                </ul>
            </OneList>
            <div style={{display:'flex',gap:'0.25rem',justifyContent:'space-between',alignItems:'center'}}>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>{setTarget();setPopOpen(true)}}>추가</Button>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>setPopOpen(true)}>수정</Button>
            </div>
            {popOpen && <CarsClassPop target={target} close={setPopOpen} />}
        </div>
    )
}

const DetailWindow = styled.div`
    position: relative;
    background: ${theme.color.white[100]};
    width: 50%;
    height: 16rem;
    border-radius: 18px;
    padding: 1rem 1rem;
`;

const MainBody = styled.div`
    padding: 1.5rem 0rem 1.5rem 0rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    overflow:auto;
    height: calc(16rem - 2rem - 40px);

    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }
`;

const ButtonBox = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 40px;
    gap: 8px;
`;

const CarsClassPop = ({target, close}) => {

    const queryClient = useQueryClient();

    const [carsClass, setCarsClass] = useState();

    const { mutate } = useSetCarsClass();

    useEffect(()=>{
        setCarsClass(target);
    },[target])

    const handleSubsClick = useCallback((updateItem) => {
        const temp = {
            mode: updateItem.ccid>0 ? 'PUT':'POST',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'등록하였습니다.',
                            height:'20vh',
                        }
                    )
                    close(false);
                }
            }
            )
    })

    const handleValueChange = (id, val) => {
        const temp  = {...carsClass,[id]:val}
        setCarsClass(temp);
    }

    const handleCloseClick = () => {
        close(false);
    }

    return (
        <CommonModalWrap style={{zIndex:1300}}>
            <DetailWindow>
                <CommonModalBar title={(target) ? '차종유형 정보' : '차종유형 등록'} close={handleCloseClick}/>
                    <MainBody>
                        <div className="row" >
                            <TextField 
                                id='ccnm' 
                                label='차종유형명' 
                                size='small' 
                                InputLabelProps={{shrink:true}} 
                                value={carsClass ? carsClass.ccnm : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        </div>
                        <div className="row" >
                            <TextField 
                                id='descr' 
                                label='설명' 
                                size='small' 
                                fullWidth
                                InputLabelProps={{shrink:true}} 
                                value={carsClass ? carsClass.descr : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        </div>
                        <ButtonBox>
                            <Button variant="contained" onClick={()=>handleSubsClick(carsClass)}>등록</Button>
                        </ButtonBox>
                    </MainBody>

            </DetailWindow>
        </CommonModalWrap>
    )
}

export default CarsClassDetail;